<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title>Dashboard</v-toolbar-title>
      </v-col>
    </v-row>
    <SumarryReports isActive="All"></SumarryReports>
    <!-- <DailyRevenue></DailyRevenue>
    <DailyActivation></DailyActivation> -->
    <!-- <DailySignUp></DailySignUp> -->
  </v-container>
</template>

<script>
import SumarryReports from "./components/dashboard_components/SumarryReports.vue";
// import DailyRevenue from "../page_components/dashboard_components/DailyRevenue.vue";
// import DailyActivation from "../page_components/dashboard_components/DailyActivation.vue";
// import DailySignUp from "../page_components/dashboard_components/DailySignUp.vue";

export default {
  name: "InventoryDashboard",
  components: {
    SumarryReports,
    // DailyRevenue,
    // DailyActivation,
    // DailySignUp
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
